import type { PropsWithChildren } from 'react';

import { useAuth } from '@drycut/auth';
import { Navigate } from 'react-router';

export function ProtectedRoute({ children }: PropsWithChildren): React.ReactNode {
  const { token, currentSlug } = useAuth();

  if (!token || !currentSlug) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
